import { HttpClient } from "@angular/common/http";
import { AbstractHttpService } from "./http-abstract.service";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { SecureFileDto, ShortUrlDto, TicketStatusDto } from "./dto";

@Injectable({
	providedIn: 'root'
})
export class HttpAnonymousTicketService extends AbstractHttpService {
	constructor(httpClient: HttpClient) {
		super(httpClient, '/api/gui/ticket');
	}
	public getStatus(ticketReference: string): Observable<TicketStatusDto> {
		return super.doGet(`/anonymous-status/${ticketReference}`);
	}
}

